import { BlockTitle } from "@blocks/Blocks";
import { cn } from "@util/helpers";

type HeaderProps = {
  /** The title of the accordion item, will be displayed at accordion header. */
  title: string;
  /** Classname for styling of accordion header */
  className?: string;
};

/**
 * component to render Events Awards accordion header
 */
const EventsAwardsAccordionHeader = ({
  className,
  title,
}: HeaderProps): React.ReactElement => {
  return (
    <BlockTitle
      text={title}
      rootClassName={cn(
        "text-base lg:text-base mb-0 font-public-sans font-semibold tracking-2% hover:underline px-6 text-left",
        className
      )}
    />
  );
};

export default EventsAwardsAccordionHeader;
